import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const benefits = [
  'Exclusive federal ownership of your brand name in all 50 states',
  'Legal authority to stop anyone from using your brand name',
  'Required for Amazon Brand Registry and e-commerce platforms',
  'Turns your brand name into a valuable, sellable business asset',
  'Blocks competitors from filing similar brand names with the USPTO',
];

const WhyNeedSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.1 });
  return (
    <section data-testid="why-need-section" id="why-register" ref={section.ref} className="py-24 md:py-32 bg-[#041B1C] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#A5BF23]/3 blur-[150px]" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className={`scroll-slide-left ${section.isVisible ? 'scroll-visible' : ''}`}>
            <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-6">WHY REGISTER YOUR BRAND NAME</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] leading-tight mb-6" style={{ fontFamily: "'Outfit', sans-serif" }}>
              An Unregistered Brand Name Is an Unprotected Brand Name
            </h2>
            <p className="text-base text-[#A0B2B2] leading-relaxed mb-8">
              Without a federal trademark on your brand name, anyone can use it in another state, list counterfeit products under it, or file the name before you do. Brand name registration puts the law on your side.
            </p>
            <ul className="space-y-3 mb-8">
              {benefits.map((b, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-[#A5BF23]/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-3 h-3 text-[#A5BF23]" />
                  </div>
                  <span className="text-sm text-[#A0B2B2]">{b}</span>
                </li>
              ))}
            </ul>
            <Button data-testid="why-need-cta" onClick={onOpenContactForm}
              className="bg-[#A5BF23] hover:bg-[#8A9F1D] text-[#041B1C] font-semibold px-8 h-11 text-sm rounded-full transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(165,191,35,0.3)]">
              Protect My Brand Name <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
          <div className={`scroll-slide-right ${section.isVisible ? 'scroll-visible' : ''}`}>
            <div className="relative rounded-2xl overflow-hidden">
              <img src="https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjB0ZWFtJTIwbWVldGluZ3xlbnwwfHx8fDE3NzYxOTgzMDh8MA&ixlib=rb-4.1.0&q=85" alt="Professional team meeting" className="w-full h-[400px] lg:h-[500px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#041B1C]/60 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;
